import _ from "lodash";

export default {
  methods: {
    validationErrorToArray(error) {
      const status = _.get(error, "response.status");
      if (status !== 422) return [];
      const errors = _.get(error, "response.data.errors");
      if (errors) {
        const result = [];
        _.forEach(_.keys(errors), key => {
          _.forEach(errors[key], value => {
            result.push(value);
          });
        });
        return result;
      }
      return [];
    },
    showValidationError(errors) {
      if (!Array.isArray(errors) || errors.length === 0)
        return Promise.reject("Error not founded.");
      return new Promise(resolve => {
        const html = [];
        if (errors.length) {
          if (errors.length === 1) html.push(`${errors[0]}`);
          else {
            html.push(`<ol>`);
            errors.forEach(error => {
              html.push(`<li>${error}</li>`);
            });
            html.push(`</ol>`);
          }
          this.$confirm(html.join(""), {
            title: this.$t("general.foundError"),
            color: "error",
            width: 400,
            icon: "mdi-alert-circle",
            buttonFalseText: "",
            buttonTrueText: this.$t("general.gotIt")
          }).then(value => {
            resolve(value);
          });
        }
      });
    },
    saveErrorHandler(error) {
      const status = _.get(error, "response.status");
      if (status === 500) {
        const message = _.get(
          error,
          "response.data.message",
          this.$t("general.error500")
        );
        return new Promise(resolve => {
          this.$confirm(message, {
            title: this.$t("general.foundError"),
            color: "error",
            width: 400,
            icon: "mdi-alert-circle",
            buttonFalseText: "",
            buttonTrueText: this.$t("general.gotIt")
          }).then(value => {
            resolve(value);
          });
        });
      } else if (status === 422) {
        return this.showValidationError(this.validationErrorToArray(error));
      } else {
        const message = this.$t("general.cannotSaveWithUnknownCause");
        return new Promise(resolve => {
          this.$confirm(message, {
            title: this.$t("general.foundError"),
            color: "error",
            width: 400,
            icon: "mdi-alert-circle",
            buttonFalseText: "",
            buttonTrueText: this.$t("general.gotIt")
          }).then(value => {
            resolve(value);
          });
        });
      }
    },
    updateErrorHandler(error) {
      const status = _.get(error, "response.status");
      if (status === 500) {
        const message = _.get(
          error,
          "response.data.message",
          this.$t("general.error500")
        );
        return new Promise(resolve => {
          this.$confirm(message, {
            title: this.$t("general.foundError"),
            color: "error",
            width: 400,
            icon: "mdi-alert-circle",
            buttonFalseText: "",
            buttonTrueText: this.$t("general.gotIt")
          }).then(value => {
            resolve(value);
          });
        });
      } else if (status === 422) {
        return this.showValidationError(this.validationErrorToArray(error));
      } else if (status === 404) {
        return new Promise(resolve => {
          const message = _.get(
            error,
            "response.data.message",
            this.$t("general.dataNotFoundForEdit")
          );
          this.$confirm(message, {
            title: this.$t("general.foundError"),
            color: "error",
            width: 400,
            icon: "mdi-alert-circle",
            buttonFalseText: "",
            buttonTrueText: this.$t("general.gotIt")
          }).then(value => {
            resolve(value);
          });
        });
      } else {
        const message = this.$t("general.cannotSaveWithUnknownCause");
        return new Promise(resolve => {
          this.$confirm(message, {
            title: this.$t("general.foundError"),
            color: "error",
            width: 400,
            icon: "mdi-alert-circle",
            buttonFalseText: "",
            buttonTrueText: this.$t("general.gotIt")
          }).then(value => {
            resolve(value);
          });
        });
      }
    },
    deleteErrorHandler(error) {
      const status = _.get(error, "response.status");
      if (status === 500) {
        const message = _.get(
          error,
          "response.data.message",
          this.$t("general.error500")
        );
        return new Promise(resolve => {
          this.$confirm(message, {
            title: this.$t("general.foundError"),
            color: "error",
            width: 400,
            icon: "mdi-alert-circle",
            buttonFalseText: "",
            buttonTrueText: this.$t("general.gotIt")
          }).then(value => {
            resolve(value);
          });
        });
      } else if (status === 404) {
        return new Promise(resolve => {
          const message = _.get(
            error,
            "response.data.message",
            this.$t("general.dataNotFoundForDelete")
          );
          this.$confirm(message, {
            title: this.$t("general.foundError"),
            color: "error",
            width: 400,
            icon: "mdi-alert-circle",
            buttonFalseText: "",
            buttonTrueText: this.$t("general.gotIt")
          }).then(value => {
            resolve(value);
          });
        });
      } else {
        const message = this.$t("general.cannotDeleteWithUnknownCause");
        return new Promise(resolve => {
          this.$confirm(message, {
            title: this.$t("general.foundError"),
            color: "error",
            width: 400,
            icon: "mdi-alert-circle",
            buttonFalseText: "",
            buttonTrueText: this.$t("general.gotIt")
          }).then(value => {
            resolve(value);
          });
        });
      }
    }
  }
};
